import {ajax} from '../utils/ajaxHelper';

/* eslint-disable complexity */
// TODO make this async?
function getRecommendedProperties({listingId, site, fallback, details, size, source, startDate, endDate, minBeds, minBaths, minSleeps, maxRate, regionId, searchTerm, unitApiUrl}) {
    let url = `/pdp/recommendedProperties?listingId=${listingId}`;
    url = site ? `${url}&site=${site}` : url;
    url = fallback === true || fallback === false ? `${url}&fallback=${fallback}` : url;
    url = details ? `${url}&details=${details}` : url;
    url = size ? `${url}&size=${size}` : url;
    url = source ? `${url}&source=${source}` : url;
    url = startDate ? `${url}&startDate=${startDate}` : url;
    url = endDate ? `${url}&endDate=${endDate}` : url;
    url = minBeds ? `${url}&minBeds=${minBeds}` : url;
    url = minBaths ? `${url}&minBaths=${minBaths}` : url;
    url = minSleeps ? `${url}&minSleeps=${minSleeps}` : url;
    url = maxRate ? `${url}&maxRate=${maxRate}` : url;
    url = regionId ? `${url}&regionId=${regionId}` : url;
    url = searchTerm ? `${url}&searchTerm=${searchTerm}` : url;
    url = unitApiUrl ? `${url}&unitApiUrl=${unitApiUrl}` : url;

    return ajax(url);
}

export default getRecommendedProperties;
export {getRecommendedProperties};
